import React from 'react'
import {observer} from 'mobx-react-lite'
import classNames from 'classnames'

import {useOnboardingStore} from '@/stores/onboarding'
import {OnboardingStep} from '@/stores/onboarding/models/onboarding'

import styles from './MobileProgressBar.scss'

export interface MobileProgressBarProps {
    className?: string
}

const MobileProgressBar: React.FC<MobileProgressBarProps> = ({className}) => {
    const store = useOnboardingStore()

    const calculateProgress = (): number => {
        const steps = [
            OnboardingStep.COMPANY_DETAILS,
            OnboardingStep.COMPANY_CONTACTS,
            OnboardingStep.OWNERS_DIRECTORS,
            OnboardingStep.BANK_DETAILS,
            OnboardingStep.OUTLETS_INFORMATION,
            OnboardingStep.REVIEW_SUBMIT
        ]

        const completedSteps = steps.filter((step) => store.stepCompletionStatus[step]).length
        const totalSteps = steps.length

        return Math.round((completedSteps / totalSteps) * 100)
    }

    const progress = calculateProgress()

    return (
        <div className={classNames(styles.progressBarContainer, className)}>
            <div className={styles.progressBarBackground}>
                <div className={styles.progressBarFill} style={{width: `${progress}%`}} />
            </div>
        </div>
    )
}

export default observer(MobileProgressBar)
